import { css } from "lit";

export const widgetStyles = css`
  :host {
    display: block;
    font-family: Inter, system-ui, sans-serif;
    inline-size: clamp(320px, 90vw, 420px);
    min-inline-size: 320px;
    max-inline-size: 420px;
    margin-inline: auto;
    box-sizing: border-box;
    color: #0f172a;
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  form {
    display: grid;
    gap: 12px;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 16px;
    background: #ffffff;
    inline-size: 100%;
  }

  form > * {
    min-width: 0;
  }

  label {
    display: grid;
    gap: 4px;
    font-size: 14px;
    min-width: 0;
  }

  input:not([type="checkbox"]):not([type="radio"]),
  select {
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    padding: 10px;
    font: inherit;
    color: #0f172a;
    background: #ffffff;
    width: 100%;
    min-width: 0;
    transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
  }

  select {
    cursor: pointer;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    padding-right: 36px;
    background-image: linear-gradient(45deg, transparent 50%, #64748b 50%),
      linear-gradient(135deg, #64748b 50%, transparent 50%);
    background-position: calc(100% - 18px) calc(50% - 2px), calc(100% - 12px) calc(50% - 2px);
    background-size: 6px 6px, 6px 6px;
    background-repeat: no-repeat;
  }

  input:not([type="checkbox"]):not([type="radio"]):hover,
  select:hover {
    border-color: #94a3b8;
  }

  input:not([type="checkbox"]):not([type="radio"]):focus,
  select:focus {
    outline: none;
    border-color: #1674ee;
    box-shadow: 0 0 0 3px rgba(22, 116, 238, 0.15);
  }

  button {
    border: 0;
    border-radius: 8px;
    padding: 10px 14px;
    background: #1674ee;
    color: #ffffff;
    font-weight: 600;
    cursor: pointer;
  }

  button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .error {
    color: #b91c1c;
    font-size: 13px;
  }

  .step {
    margin: 0;
    font-size: 13px;
    font-weight: 600;
    color: #334155;
  }

  .helper {
    margin: 0;
    font-size: 12px;
    color: #475569;
  }

  .intro-title {
    margin: 0;
    font-size: 22px;
    line-height: 1.3;
    color: #0f172a;
  }

  .intro-copy {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
    color: #334155;
  }

  .summary {
    display: grid;
    gap: 6px;
    font-size: 14px;
  }

  .summary p {
    margin: 0;
  }

  .actions {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    justify-content: flex-end;
    min-width: 0;
  }

  .actions button {
    min-width: 0;
  }

  .secondary {
    background: #e2e8f0;
    color: #0f172a;
  }

  .success {
    border: 1px solid #bbf7d0;
    border-radius: 12px;
    padding: 12px;
    background: #f0fdf4;
    font-size: 14px;
  }

  pre {
    overflow: auto;
    max-height: 220px;
  }

  .preview-card {
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 12px;
    background: #f8fafc;
    margin-bottom: 8px;
  }

  .preview-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 0;
    font-size: 13px;
  }

  .preview-row:not(:last-child) {
    border-bottom: 1px solid #e2e8f0;
  }

  .preview-label {
    color: #64748b;
  }

  .preview-value {
    font-weight: 600;
    color: #0f172a;
  }

  .preview-value.blurred {
    filter: blur(6px);
    user-select: none;
    color: #1674ee;
  }

  .preview-value .lock {
    filter: none;
    margin-left: 4px;
  }

  .social-proof {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: #64748b;
    margin-bottom: 8px;
  }

  .social-proof .dot {
    width: 6px;
    height: 6px;
    background: #22c55e;
    border-radius: 50%;
  }

  .reassurance {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    color: #94a3b8;
    margin-top: 4px;
  }

  .reassurance svg {
    width: 12px;
    height: 12px;
    flex-shrink: 0;
  }

  .unlock-title {
    font-size: 15px;
    font-weight: 600;
    color: #0f172a;
    margin: 0 0 12px 0;
    text-align: center;
  }

  .intro-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: #f0fdf4;
    color: #15803d;
    font-size: 12px;
    font-weight: 600;
    padding: 4px 10px;
    border-radius: 20px;
    margin-bottom: 12px;
  }

  .intro-badge svg {
    width: 14px;
    height: 14px;
  }

  .intro-benefits {
    display: grid;
    gap: 8px;
    margin: 12px 0;
  }

  .intro-benefit {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font-size: 13px;
    color: #334155;
    line-height: 1.4;
  }

  .intro-benefit .check {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    background: #dcfce7;
    color: #15803d;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
  }

  .intro-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 11px;
    color: #94a3b8;
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid #f1f5f9;
  }

  .result-card {
    border: 1px solid #dbeafe;
    border-radius: 10px;
    padding: 12px;
    background: #eff6ff;
    display: grid;
    gap: 8px;
  }

  .result-title {
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    color: #0f172a;
  }

  .result-title.positive {
    color: #166534;
  }

  .result-title.negative {
    color: #991b1b;
  }

  .detail-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
    background: #ffffff;
    border: 1px solid #bfdbfe;
    border-radius: 8px;
    overflow: hidden;
  }

  .detail-table thead {
    background: #1674ee;
    color: #ffffff;
  }

  .detail-table th,
  .detail-table td {
    padding: 8px;
    border-bottom: 1px solid #e2e8f0;
    text-align: left;
  }

  .expert-actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    margin-top: 4px;
  }

  .expert-actions button {
    flex: 1;
  }

  .expert-card {
    border: 1px solid #dbeafe;
    border-radius: 12px;
    padding: 14px;
    background: linear-gradient(180deg, #f8fbff 0%, #f1f5f9 100%);
    display: grid;
    gap: 10px;
  }

  .expert-eyebrow {
    display: inline-flex;
    align-items: center;
    width: fit-content;
    border-radius: 999px;
    background: #dbeafe;
    color: #1e40af;
    font-size: 11px;
    font-weight: 700;
    padding: 4px 10px;
    letter-spacing: 0.01em;
    text-transform: uppercase;
  }

  .expert-title {
    margin: 0;
    font-size: 20px;
    line-height: 1.2;
    color: #0f172a;
  }

  .expert-copy {
    margin: 0;
    font-size: 13px;
    color: #334155;
    line-height: 1.45;
  }

  .expert-options {
    display: grid;
    gap: 8px;
  }

  .expert-option {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    border: 1px solid #bfdbfe;
    border-radius: 10px;
    background: #ffffff;
    cursor: pointer;
    font-size: 14px;
    color: #0f172a;
  }

  .expert-option:hover {
    background: #f8fbff;
  }

  .expert-option input {
    margin: 0;
  }

  .expert-choice {
    min-height: 44px;
    border-radius: 10px;
    border: 1px solid #bfdbfe;
    background: #ffffff;
    color: #1e3a8a;
    font-weight: 700;
  }

  .expert-choice:hover {
    background: #f8fbff;
  }

  .expert-choice.selected-yes {
    border-color: #1674ee;
    background: #1674ee;
    color: #ffffff;
  }

  .expert-choice.selected-no {
    border-color: #94a3b8;
    background: #f1f5f9;
    color: #0f172a;
  }

  .expert-feedback {
    border-radius: 10px;
    padding: 10px 12px;
    font-size: 13px;
    font-weight: 600;
    border: 1px solid #dcfce7;
    color: #166534;
    background: #f0fdf4;
  }

  .expert-feedback.neutral {
    border-color: #e2e8f0;
    color: #334155;
    background: #f8fafc;
  }

  .expert-feedback.error {
    border-color: #fecaca;
    color: #991b1b;
    background: #fef2f2;
  }

  .expert-reset {
    margin-top: 2px;
    width: 100%;
    background: #e2e8f0;
    color: #0f172a;
  }

  .country-box {
    position: relative;
  }

  .country-options {
    position: absolute;
    left: 0;
    right: 0;
    top: calc(100% + 4px);
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    background: #ffffff;
    max-height: 220px;
    overflow: auto;
    z-index: 10;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  }

  .country-option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    border: 0;
    border-bottom: 1px solid #f1f5f9;
    background: #ffffff;
    color: #0f172a;
    padding: 10px;
    text-align: left;
    cursor: pointer;
    font-size: 13px;
    border-radius: 0;
  }

  .country-option:hover {
    background: #f8fafc;
  }

  .country-code {
    color: #64748b;
    font-size: 12px;
    margin-left: 8px;
  }
`;
